export default __webpack_public_path__ + "static/media/upload 1.c482f90d.svg";